/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BedType
 */
export interface BedType {
    /**
     * 
     * @type {string}
     * @memberof BedType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BedType
     */
    name: string;
}

/**
 * Check if a given object implements the BedType interface.
 */
export function instanceOfBedType(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function BedTypeFromJSON(json: any): BedType {
    return BedTypeFromJSONTyped(json, false);
}

export function BedTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
    };
}

export function BedTypeToJSON(value?: BedType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

